import { useTranslation } from "react-i18next";
import { IS_E2E } from "@/lib/isE2E";
import { BrandLogo } from "@/components/redesign/BrandLogo";

const SplashScreen = () => {
  const { t } = useTranslation();

  if (IS_E2E) return null;

  return (
    <main
      className="flex h-dvh min-h-0 w-screen items-center justify-center overflow-hidden bg-[var(--dp-brand-button)]"
    >
      <div className="flex h-[150px] w-[280px] flex-col items-center justify-between">
        <BrandLogo inverse />
        <div
          aria-label={t("splash.optimizing_study_plan")}
          aria-valuetext={t("splash.optimizing_study_plan")}
          className="flex w-[265px] flex-col items-center gap-3"
          role="progressbar"
        >
          <div className="relative h-[10px] w-[265px] overflow-hidden rounded-full bg-white/20">
            <span className="dp-loader-segment absolute left-0 top-0 h-[10px] w-[70px] rounded-full bg-white" />
          </div>
          <p className="whitespace-nowrap text-center text-[16px] font-semibold uppercase leading-6 tracking-[0.08px] text-white">
            {t("splash.optimizing_study_plan")}...
          </p>
        </div>
      </div>
    </main>
  );
};

export default SplashScreen;
